"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var DevicesMinSize;
/**
 * Retorna o tipo do dispositivo de acordo com o `getScreenSizeClassification`
 * ```js
 * {
 *   phone: '<768px',
 *   tablet: '≥768px',
 *   desktop: '≥992px',
 * }
 * ```
 * @see {getScreenSizeClassification}
 */

(function (DevicesMinSize) {
  DevicesMinSize[DevicesMinSize["phone"] = 0] = "phone";
  DevicesMinSize[DevicesMinSize["tablet"] = 768] = "tablet";
  DevicesMinSize[DevicesMinSize["desktop"] = 992] = "desktop";
})(DevicesMinSize || (DevicesMinSize = {}));

const getDeviceTypeByScreen = () => {
  if (window.innerWidth >= DevicesMinSize.desktop) return 'desktop';
  if (window.innerWidth >= DevicesMinSize.tablet) return 'tablet';
  return 'phone';
};

var _default = getDeviceTypeByScreen;
exports.default = _default;